import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { loginToSystem } from "../services/api";
import Unauthorized from "../components/Unauthorized";
import CustomSpinner from "../components/CustomSpinner";
import StorageService from "../utils/StorageService";
import { useAuth } from "../context/AuthContext";
import { useAppEnv } from '../context/AppEnvContext';
const AuthGuard = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const { setAuthData } = useAuth(); // Access the context setter
  const { token } = useParams(); // Call useParams at the top level
  const env = useAppEnv();
  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        if (!token) {
          throw new Error("Invalid request");
        }
        const _guard_ = StorageService.get("_guard_");
        if (_guard_ !== token) {
          // Clear old data and update with new accountId
          StorageService.clear();
          StorageService.set("_guard_", token);
        }

        // Call loginToSystem API
        const loginUrl = `${env.REACT_APP_API_BASE_URL}/${env.REACT_APP_LOGIN_URL}`;
        const loginResponse = await loginToSystem({
          url: loginUrl,
          data: token,
        });
        if (!loginResponse || !loginResponse.AccessToken) {
          throw new Error("Login failed");
        }

        // Store the data in context
        setAuthData({
          clientId: loginResponse.ClientID,
          eventId: loginResponse.EventID,
          accountId1: loginResponse.AccountID,
          accountId2: loginResponse.AccountIDTo,
          accessToken: loginResponse.AccessToken,
        });
        StorageService.set(`system_${token}`, loginResponse.AccessToken);
        setAuthorized(true);
      } catch (error) {
        console.error("Unauthorized:", error);
        setAuthorized(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuthorization();
  }, [location, setAuthData]);

  if (loading) {
    return <CustomSpinner />;
  }

  if (!authorized) {
    return <Unauthorized />;
  }

  return <>{children}</>;
};

export default AuthGuard;
